import "./FooterStyles.css"

import { FaInstagram, FaLinkedin, FaNodeJs, FaReact, FaHtml5, FaCss3, FaGithub, FaJsSquare } from "react-icons/fa"

const Footer = () => {
  return (
    <div className="footer">
        <div className="footer-container">
            <div className="left">
                {/* <div className="location">
                    <FaHome size={20} style={{color: "#fff", marginRight: "2rem"}}/>
                    <p>123 Test Road</p>
                    <p>Texas</p>
                </div> */}
                {/* <div className="phone">
                    <h4>
                    <FaPhone size={20} style={{color: "#fff", marginRight: "2rem", paddingTop: "0.3rem"}}/>
                    972-363-6244
                    </h4>
                </div> */}
                <div className="name">
                    <h1>Yeshas Nath</h1>
                </div>
                <div className="email">
                    <h4>
                    yeshas.nath@gmail.com
                    </h4>
                </div>
                <div className="social">
                    <a href="https://instagram.com/yeshasn4?igshid=NTc4MTIwNjQ2YQ==">
                        <FaInstagram size={25} style={{color: "#fff", marginRight: "1rem"}}></FaInstagram>
                    </a>
                    <a href="https://linkedin.com/in/yeshas-nath">
                        <FaLinkedin size={25} style={{color: "#fff", marginRight: "1rem"}}></FaLinkedin>
                    </a>
                    <a href="https://www.github.com/yeshasn">
                        <FaGithub size={25} style={{color: "#fff", marginRight: "1rem"}}></FaGithub>
                    </a>
                </div>
                <div className="tools">
                    <p>Developed using</p>
                    <div className="icons">
                        <FaNodeJs size={30} style={{color: "#808080", marginRight: "1rem"}}></FaNodeJs>
                        <FaReact size={30} style={{color: "#808080", marginRight: "1rem"}}></FaReact>
                        <FaHtml5 size={30} style={{color: "#808080", marginRight: "1rem"}}></FaHtml5>
                        <FaCss3 size={30} style={{color: "#808080", marginRight: "1rem"}}></FaCss3>
                        <FaJsSquare size={30} style={{color: "#808080", marginRight: "1rem"}}></FaJsSquare>
                    </div>
                </div>
            </div>
            <div className="right">
                

            </div>
        </div>
    </div>
  )
}

export default Footer
